<template lang="html">
 <div class="container">
     <div class="row">
         <div class="col s12">
             <img class="center responsive-img" src="@/assets/images/hmy_claim.png"/>
         </div>
     </div>
     <div class="row">
         <div class="col s12 m6">
             <div class="card grey darken-2">
                 <div class="card-content white-text">
                     <span class="card-title">Merci!</span>
                     <p>HMY Group vous remercie pour votre participation à l'amélioration des produits.</p>
                 </div>
                 <div class="card-content ">
                     <span class="card-title center"> <router-link class="btn-large waves-effect waves-light light-blue accent-2" :to="{ name: 'Idea' }"><i class="material-icons">add_circle_outline</i>UNE AUTRE IDEE ? </router-link> </span>
                     <span class="card-title center"> <a href="mailto:amelioration.montage@hmy-group.com" class="btn-large waves-effect waves-light light-blue"><i class="material-icons">mail_outline</i>NOUS CONTACTER </a> </span>
                     <span class="card-title center"> <router-link class="btn-large waves-effect waves-light grey lighten-1" :to="{ name: 'Home' }"><i class="material-icons">arrow_back</i>RETOUR A L'ACCUEIL </router-link> </span>

                 </div>

             </div>
         </div>
     </div>

 </div>
</template>

<script>

export default {
    name:'Declared',
    data(){
        return {

        }
    }
}
</script>

<style lang="css" scoped>

.btn-large{
    width: 100% !important;
}

i{
    position: absolute;
    top: 11px;
    left: 24px;
}

</style>
